import React from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Box } from '@mui/material';
import enUS from 'date-fns/locale/en-US';

const locales = { 'en-US': enUS };
const localizer = dateFnsLocalizer({ format, parse, startOfWeek, getDay, locales });

export const TYPE_COLORS = {
  event: '#1976d2',
  sports: '#16a34a',
  cultural: '#7c3aed',
  meeting: '#0891b2',
  other: '#6b7280',
  holiday: '#ef4444',
  exam: '#f59e0b',
};

const eventStyleGetter = (event) => ({
  style: {
    backgroundColor: event.color,
    borderRadius: '4px',
    border: 'none',
    color: '#fff',
    fontSize: '0.75rem',
    padding: '2px 6px',
  },
});

/**
 * Shared react-big-calendar presentational wrapper.
 * `events` must already be mapped to {id,title,start,end,resource,color}.
 */
export default function SchoolCalendar({
  events,
  date,
  view,
  views,
  onNavigate,
  onView,
  onSelectEvent,
  onSelectSlot,
  selectable = false,
  components,
  height = 600,
  step,
  timeslots,
  scrollToTime,
}) {
  return (
    <Box sx={{ height, '& .rbc-calendar': { fontFamily: 'inherit' } }}>
      <Calendar
        localizer={localizer}
        events={events}
        date={date}
        view={view}
        views={views}
        onView={onView}
        onNavigate={onNavigate}
        onSelectSlot={onSelectSlot}
        onSelectEvent={onSelectEvent}
        selectable={selectable}
        eventPropGetter={eventStyleGetter}
        components={components}
        step={step}
        timeslots={timeslots}
        scrollToTime={scrollToTime}
        popup
        style={{ height: '100%' }}
      />
    </Box>
  );
}
